import { render } from "./BaoCaoCongTacYTeTruongHocDaGoi.vue?vue&type=template&id=b9e0a5e8&ts=true"
import script from "./BaoCaoCongTacYTeTruongHocDaGoi.vue?vue&type=script&lang=ts"
export * from "./BaoCaoCongTacYTeTruongHocDaGoi.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/BaoCao/CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__